module.exports = __webpack_public_path__ + "static/banner-entradas-e1dc5b174d3b7f5d1f583e14d7463f2e.jpg";